import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import Dropdown from "../../../../controls/Dropdown";
import BackEnd from "../../../../backend/BackEnd";
import {successToast} from "../../../../utils/toasts";
import ProcessButton from "../../../../controls/ProcessButton";

class ProductAttachModal extends Component {
    static propTypes = {
        articleId: PropTypes.number.isRequired,
        show: PropTypes.bool.isRequired,
        onAttach: PropTypes.func.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        isLoading: false,
        productId: null
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.show)
            this.setState({productId: null});
    }

    render() {
        const {articleId, onAttach, ...props} = this.props;
        return (
            <Modal {...props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Связать с эталонным артикулом</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className={this.state.isLoading ? 'form-loading' : ''}>
                        <fieldset className="form-group">
                            <label className="control-label required" htmlFor="company">
                                Эталонный артикул
                            </label>
                            <Dropdown placeholder="Выберите эталонный артикул..."
                                      dataSource={new BackEnd.ArticlesAdmin.SearchProducts()}
                                      onChange={event => this.setState({productId: event.target.value})}/>
                        </fieldset>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <ProcessButton type="button" className="btn btn-primary"
                                   disabled={!this.state.productId}
                                   isLoading={this.state.isLoading}
                                   onClick={() => this.attachProduct()}>
                        Связать
                    </ProcessButton>
                    <ProcessButton type="button" className="btn btn-default"
                                   isLoading={this.state.isLoading}
                                   onClick={props.onHide}>
                        Отмена
                    </ProcessButton>
                </Modal.Footer>
            </Modal>
        )
    }

    async attachProduct() {
        const {articleId, onAttach, onHide} = this.props;
        const {productId} = this.state;

        let attachProductEndpoint = new BackEnd.ArticlesAdmin.AttachProduct(this);
        let result = await attachProductEndpoint.call({articleId, productId});

        if (result.success) {
            successToast(`Артикул был успешно связан с эталонным`);
            onAttach();
            onHide();
        }
    }
}

export default ProductAttachModal;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Articles/modals/ProductAttachModal.js